var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-table',{attrs:{"column":_vm.column,"rows":_vm.rows}})}
var staticRenderFns = []

export { render, staticRenderFns }